import { render, staticRenderFns } from "./NCExam.vue?vue&type=template&id=8151f120&"
import script from "./NCExam.vue?vue&type=script&lang=js&"
export * from "./NCExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports